var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5161 10.4984H20.5318C21.1209 10.4984 21.5984 10.976 21.5984 11.5651V17.7965V18.0984C21.5984 19.203 20.703 20.0984 19.5984 20.0984H4.79844M2.39844 4.9651V17.9984C2.39844 19.1582 3.33864 20.0984 4.49844 20.0984V20.0984C5.65823 20.0984 6.59844 19.1582 6.59844 17.9984V11.5651C6.59844 10.976 7.076 10.4984 7.6651 10.4984H19.4651V7.97687C19.4651 7.38777 18.9875 6.9102 18.3984 6.9102H11.371L9.74104 4.38641C9.54456 4.08219 9.20715 3.89844 8.845 3.89844H3.4651C2.876 3.89844 2.39844 4.376 2.39844 4.9651Z",
    stroke: "#555555",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpenIcon);
export default __webpack_public_path__ + "static/media/FolderOpenIcon.3cab2378ea34e3e12bb17b11237c6fe6.svg";
export { ForwardRef as ReactComponent };